export const laboreTamRouting = [
  {
    path: "/labor/laboreTamMembers/list/:id",
    name: "labor-laboreTamMembers-list",
    meta: { title: "班组人员管理" },
    component: () =>
      import(
        /* webpackChunkName: "labor-team-list" */ "@/views/labor/laborteam-members/list/index.vue"
      ),
  },
];
